import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home',
    component: Home
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/studentFill',
    name: 'StudentFill',
    component: () => import('../views/StudentFill.vue')
  },
  {
    path: '/teacherFill',
    name: 'TeacherFill',
    component: () => import('../views/TeacherFill.vue')
  },
  {
    path: '/teachers',
    name: 'Teachers',
    redirect: '/teachers/teacherList',
    component: () => import('../views/Teachers.vue'),
    children: [
      {
        path: '/teachers/teacherDetail',
        name: 'TeacherDetail',
        component: () => import('../views/TeacherDetail.vue')
      },
      {
        path: '/teachers/teacherList',
        name: 'TeacherList',
        component: () => import('../views/TeacherList.vue')
      },
      {
        path: '/teachers/appointment',
        name: 'Appointment',
        component: () => import('../views/Appointment.vue')
      },
      {
        path: '/order',
        name: 'Order',
        component: () => import('../views/Order.vue')
      }
    ]
  },
  {
    path: '/system',
    name: 'System',
    component: () => import('../views/System.vue')
  },
  {
    path: '/channel',
    name: 'Channel',
    component: () => import('../views/Channel.vue')
  },
  {
    path: '/question',
    name: 'Question',
    component: () => import('../views/Question.vue')
  },
  {
    path: '/user',
    name: 'User',
    redirect: '/user/info',
    component: () => import('../views/User.vue'),
    children: [
      {
        path: '/user/info',
        name: 'Info',
        component: () => import('../views/Info.vue')
      },
      {
        path: '/user/info2',
        name: 'Info2',
        component: () => import('../views/Info2.vue')
      },
      {
        path: '/user/myteacher',
        name: 'Myteacher',
        component: () => import('../views/Myteacher.vue')
      },
      {
        path: '/user/mystudent',
        name: 'Mystudent',
        component: () => import('../views/Mystudent.vue')
      },
      {
        path: '/user/timetable',
        name: 'Timetable',
        component: () => import('../views/Timetable.vue')
      },
      {
        path: '/user/timetable2',
        name: 'Timetable2',
        component: () => import('../views/Timetable2.vue')
      },
      {
        path: '/user/courses',
        name: 'Courses',
        component: () => import('../views/Courses.vue')
      },
      {
        path: '/user/courses2',
        name: 'Courses2',
        component: () => import('../views/Courses2.vue')
      },
      {
        path: '/user/news',
        name: 'News',
        component: () => import('../views/News.vue'),
      },
      {
        path: '/user/income',
        name: 'Income',
        component: () => import('../views/Income.vue')
      },
      {
        path: '/user/changepsw',
        name: 'Changepsw',
        component: () => import('../views/Changepsw.vue')
      },
      {
        path: '/user/invite',
        name: 'Invite',
        component: () => import('../views/Invite.vue')
      },
      {
        path: '/user/rebook',
        name: 'Rebook',
        component: () => import('../views/Rebook.vue')
      },
    ]
  },
  {
    path: '/prestore',
    name: 'Prestore',
    component: () => import('../views/Prestore.vue')
  },
  {
    path: '/report',
    name: 'Report',
    component: () => import('../views/Report.vue')
  },
  {
    path: '/arrange',
    name: 'Arrange',
    component: () => import('../views/Arrange.vue')
  },
  {
    path: '/studentDetail',
    name: 'StudentDetail',
    component: () => import('../views/StudentDetail.vue')
  },
  {
    path: '/liveBroadcast',
    name: 'LiveBroadcast',
    component: () => import('../views/LiveBroadcast.vue')
  },
  {
    path: '/whiteBoard',
    name: 'WhiteBoard',
    component: () => import('../views/WhiteBoard.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
